import { ExplorerScreen } from 'features/Explorer'

// Login/Register
import LoginScreen from './login/LoginScreenCN/LoginScreenCN'
import EmailConfirm from './login/LoginScreen/EmailConfirm'
import RegisterConfirm from './login/LoginScreen/RegisterConfirm'

import Home from './Home'
// import Profile from './Profile'
// import Company_Profile from './admin/Company_Profile'

// Admin
import Admin_Index from './admin/Admin_Index'
import Admin_Show from './admin/Admin_Show'
import Admin_SiteDetails_Show from './admin/Admin_SiteDetails_Show'
import ImagesGalleryCN from './admin/contentPages/ImagesGalleryCN'
import MyLibraryDocumentsCN from './admin/contentPages/MyLibraryDocumentsCN'
import PortfoliosListCN from './admin/contentPages/PortfoliosListCN'
import ProjectsListCN from './admin/contentPages/ProjectsListCN'
import LocationsListCN from './admin/contentPages/LocationsListCN'
import BulkLoadLocationsCN from './admin/contentPages/BulkLoadLocationsCN'
import TasksTemplateCN from './admin/contentPages/TasksTemplateCN'
import SiteDetailsTemplateCN from './admin/contentPages/SiteDetailsTemplateCN'
import ScoringCriteriaTemplateCN from './admin/contentPages/ScoringCriteriaTemplateCN'
import AcquisitionTemplateCN from './admin/contentPages/AcquisitionTemplateCN'
import OperatingTemplateCN from './admin/contentPages/OperatingTemplateCN'
import ROIAnalysisTemplateCN from './admin/contentPages/ROIAnalysisTemplateCN'
import RiskTemplateCN from './admin/contentPages/RiskTemplateCN'
import ProsConsTemplateCN from './admin/contentPages/ProsConsTemplateCN'
import LookupListsCN from './admin/contentPages/LookupListsCN'
import CleanupCN from './admin/contentPages/CleanupCN'
import AiUsageCN from './admin/contentPages/AiUsageCN'
import UserProfileCN from './admin/contentPages/UserProfileCN'

// ArchiveLibrary
import ArchiveLibrary_Index from './archiveLibrary/ArchiveLibrary_Index'
import ArchiveLibrary_Show from './archiveLibrary/ArchiveLibrary_Show'

// Chat

// Community
import Community_Page from './community/Community_Page'

// Locations
import Locations_Index from './locations/Locations_Index'
import Locations_New from './locations/components/Locations_New'
import Locations_Show from './locations/Locations_Show' // _OLD
import Locations_Project_Show from './locations/Locations_Project_Show' // Projects
import Locations_IndexCN from './locations/Locations_IndexCN'
import Locations_ShowCN from './locations/Locations_ShowCN'
import Locations_Projects_ShowCN from './locations/Locations_Projects_ShowCN'

// Partners
import Partners_Index from './partners/Partners_Index'

// Partner Apps
import PartnerApps_Index from './partnerApps/PartnerApps_Index'
import PartnerApps_Show from './partnerApps/PartnerApps_Show'

// Portfolios
import Portfolios_Index from './portfolios/Portfolios_Index'
import Portfolios_Show from './portfolios/Portfolios_Show'
import Portfolios_IndexCN from './portfolios/Portfolios_IndexCN'
import Portfolios_ShowCN from './portfolios/Portfolios_ShowCN'

// Evaluations
import Evaluations_IndexCN from './evaluations/Evaluations_IndexCN'
import Evaluations_ShowCN from './evaluations/Evaluations_ShowCN'

// Projects
import LocationProjects from './locations/navPages/LocationProjects'
import Location_Project_Show from './locations/Locations_Project_Show'

// Projects Index
import Projects_Index from './projects/Projects_Index'
import Projects_Show from './projects/Projects_Show'
import Projects_IndexCN from './projects/Projects_IndexCN'
import Projects_ShowCN from './projects/Projects_ShowCN'

// TasksCN
import TasksCN_Index from './taskscn/TasksCN_Index'

// Templates
import Templates_Index from './templates/Templates_Index'
import TemplateTask_Show from './templates/TemplateTask_Show'
import TemplateSiteDetail_Show from './templates/TemplateSiteDetail_Show'

// OAuth
import OAuthConsent from './oauth/OAuthConsent'

// 404 Not Found
import FourOhFour from './FourOhFour'

const SCREENS = {
	// Login/Register
	LoginScreen,
	EmailConfirm,
	RegisterConfirm,

	Home,
	// Profile,
	// Company_Profile,

	// Locations
	Locations_Index,
	Locations_New,
	Locations_Show,
	Locations_Project_Show, // Projects
	Locations_IndexCN,
	Locations_ShowCN,
	Locations_Projects_ShowCN,

	LocationProjects,
	Location_Project_Show,

	// Chats

	// Commons
	Community_Page,

	// Partner Apps
	PartnerApps_Index,
	PartnerApps_Show,

	// TasksCN
	TasksCN_Index,

	// Templates
	Templates_Index,
	TemplateSiteDetail_Show,
	TemplateTask_Show,

	// Partners
	Partners_Index,

	// Portfolios
	Portfolios_Index,
	// Portfolios_New,
	Portfolios_Show,
	Portfolios_IndexCN,
	Portfolios_ShowCN,
	Evaluations_IndexCN,
	Evaluations_ShowCN,

	// Projects
	Projects_Index,
	Projects_Show,
	Projects_IndexCN,
	Projects_ShowCN,

	// Admin
	Admin_Index,
	Admin_Show,
	Admin_SiteDetails_Show,
	ImagesGalleryCN,
	MyLibraryDocumentsCN,
	PortfoliosListCN,
	ProjectsListCN,
	LocationsListCN,
	BulkLoadLocationsCN,
	TasksTemplateCN,
	SiteDetailsTemplateCN,
	ScoringCriteriaTemplateCN,
	AcquisitionTemplateCN,
	OperatingTemplateCN,
	ROIAnalysisTemplateCN,
	RiskTemplateCN,
	ProsConsTemplateCN,
	LookupListsCN,
	CleanupCN,
	AiUsageCN,
	UserProfileCN,

	// ArchiveLibrary
	ArchiveLibrary_Index,
	ArchiveLibrary_Show,

	// Explorer
	ExplorerScreen,

	// OAuth
	OAuthConsent,

	// 404 Not Found
	FourOhFour,
}

export default SCREENS
